import React, { FC } from "react";
import { FiChevronRight } from "react-icons/fi";
import { Booking } from "../../../../../logic/api";
import { useDate } from "../../../../../utility/useDate";
import { fullVehicleDescription, locationDescription } from "../condensedLayoutUtils";
import styles from "../styles";

interface KeyHeldProps {
  booking: Booking;
  onClick: () => void;
  rowIndex: number;
}

export const KeyHeldRow: FC<KeyHeldProps> = ({
  booking,
  onClick,
  rowIndex,
}) => {
  const { toFormattedFullDateTimeString } = useDate();
  const { ref, vehicle, vehicleKey } = booking;

  const rowStyles = {
    ...(rowIndex % 2 ? styles.tableRowOdd : styles.tableRowEven),
    cursor: "pointer",
  };

  return (<tr style={rowStyles} onClick={onClick}>
    <td style={styles.tableCell}>{ref}</td>
    <td style={styles.tableCell}>{vehicleKey.location?.name}</td>
    <td style={styles.tableCell}>{locationDescription(vehicleKey.location)}</td>
    <td style={styles.tableCell}>{vehicle.registration}</td>
    <td style={styles.tableCell}>{fullVehicleDescription(vehicle)}</td>
    <td style={styles.tableCell}>{toFormattedFullDateTimeString(vehicleKey.movementDate ?? undefined)}</td>
    <td style={styles.tableCell}><FiChevronRight /></td>
  </tr>)
}
